import { useEffect } from 'react';
import type { AnyBlockHandle } from '../core/types';
import { useEventScope } from './useEventScope';

export function useBlockHandle(
  semanticId: string | undefined,
  handleFactory: () => AnyBlockHandle,
  deps: unknown[],
): void {
  const scope = useEventScope();

  useEffect(() => {
    if (!semanticId || !scope) return;

    const handle = handleFactory();
    scope.registry.register(semanticId, handle);

    const storedParams = scope.params.get(semanticId);
    if (storedParams && 'setParams' in handle) {
      (handle as { setParams: (p: Record<string, unknown>) => void }).setParams(storedParams);
    }

    return () => {
      scope.registry.unregister(semanticId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [semanticId, scope, ...deps]);
}
